import { Injectable } from '@angular/core';
import { NetworkService } from './network.service';
import { BehaviorSubject, Subscription } from 'rxjs';
import { SharedService } from '../modules/shared/shared.service';
import { Store } from '@ngrx/store';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class IntegrationsService {
  botId: any[] = [];
  integrations: any[] = [];
  integration$: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  masterIntegration$: BehaviorSubject<Array<any>> = new BehaviorSubject([]);
  isRender = false;

  brandName: string;
  subscription$: Subscription;
  constructor(
    private networkService: NetworkService,
    private sharedService: SharedService,
    private store: Store<any>,
  ) {
    this.subscription$ = this.store.subscribe(
      ({ agencyDetails }) => {
        this.brandName = agencyDetails?.meta?.brand || 'BotPenguin';
      });
  }

  createAccountIntegration(provider: string, credentials: any) {
    return this.networkService.httpRequest(`integrations/account-integrations/credentials/${provider}`, {
      integrationCredentials: { ...credentials }
    }, 'POST');
  }

  deleteAccountIntegration(provider: string) {
    return this.networkService.httpRequest(`integrations/account-integrations/credentials/${provider}`, {}, 'DELETE');
  }

  getAccountIntegration(provider: string) {
    return this.networkService.httpRequest(`integrations/account-integrations/credentials/${provider}`);
  }

  getActivities(provider: string, _integration: string) {
    return this.networkService.httpRequest(`integrations/account-integrations/${provider}/activities/${_integration}`);
  }

  getActivitiesGeneric(provider: string, _integration: string, page: number) {
    return this.networkService
      .httpRequest(`integrations/account-integrations/activities/${_integration}?provider=${provider}&page=${page}`);
  }

  setSmsDefault(payload: any) {
    return this.networkService.httpRequest('integrations/account-integrations/credentials/sms/default', {
      channels: {
        sms: payload.channels.sms
      },
      integrationId: payload.integrationId
    }, 'POST');

  }

  sendSms(provider: string, payload: any) {
    return this.networkService.httpRequest(`integrations/account-integrations/${provider}/sms`, {
      _user: payload._user,
      _agency: payload._agency,
      _bot: payload._bot,
      type: payload.type,
      _subscriber: payload._subscriber,
      leadPhoneNumber: payload.leadPhoneNumber,
      sentBy: payload.sentBy,
      text: payload.text,
      status: payload.status,
      botType: payload.botType,
      _integration: payload._integration
    }, 'POST');
  }

  getIntegrationsList(): void {
    this.sharedService.loader('start');
    this.networkService
      .httpRequest('integrations/list')
      .then((integrations: any[]) => {
        this.integrations = integrations;
        return this.networkService.httpRequest(
          'integrations/mapping/list?bot=' + this.sharedService.selectedBotMeta._id
        );
      })
      .then((mappings: any[]) => {
        this.integrations = this.integrations.map(i => {
          const mapping = mappings.find(m => m.slug === i.slug) || undefined;
          return {
            ...i,
            mapping,
            connected: !!mapping,
            description: i.description.replace(/botpenguin/gi, this.brandName),
            shortDescription: i.description.replace(/botpenguin/gi, this.brandName),
          };
        });
        this.integration$.next(this.integrations);
      })
      .catch(error => this.sharedService.showToast('error', '', error || error.message))
      .finally(() => {
        this.sharedService.loader('stop');
        this.isRender = true;
      });
  }

  createIntegration(payload: any) {
    return this.networkService.httpRequest(
      'integrations/mapping',
      {
        ...payload,
        _bot: this.sharedService.selectedBotMeta._id || sessionStorage.getItem('currentId'),
      },
      'POST'
    );
  }
  deleteIntegration(payload: any) {
    return this.networkService.httpRequest(
      'integrations/mapping/' + payload._id,
      {},
      'DELETE'
    );
  }
  updateIntegration(payload: any) {
    return this.networkService.httpRequest(
      'integrations/mapping/' + payload._id,
      {
        ...payload,
        _bot: this.sharedService.selectedBotMeta._id || sessionStorage.getItem('currentId'),
      },
      'PUT'
    );
  }

  masterIntegrationSetup(payload: any) {
    return this.networkService.httpRequest(
      'integrations/',
      {
        ...payload,
      },
      'POST'
    );
  }
  createMasterIntegration(payload: any) {
    return this.networkService.httpRequest(
      'integrations/mapping',
      {
        ...payload,
      },
      'POST'
    );
  }
  retrieveMasterIntegrationsList() {
    return this.networkService
      .httpRequest('integrations/list?integrations=myMasterIntegrations')
      .then((integrations: any) => {
        return this.currentMasterIntegration().then((mappingsData: any) => {
          return integrations.map((integration) => {
            const mapping =
              mappingsData.find((map) => (integration.slug === map.slug && map._bot === this.sharedService.selectedBotMeta._id)) ||
              undefined;
            return {
              ...integration,
              connected: mapping ? true : false,
            };
          });
        });
      });
  }
  currentMasterIntegration() {
    // return  this.networkService.httpRequest('integrations/mapping/list?bot=' + this.sharedService.selectedBotMeta._id)
    return this.networkService.httpRequest('integrations/mapping/list');
  }

  getleadid(payload: any) {
    const _bot = this.sharedService.selectedBotMeta._id;
    return this.networkService.httpRequest(`integrations/common/get-leadId?botId=${_bot}`,
      null,
      'GET'
    );
  }


  getfolderid(payload: any) {
    const _bot = this.sharedService.selectedBotMeta._id;
    return this.networkService.httpRequest(`integrations/common/get-folderId?botId=${_bot}`,
      null,
      'GET'
    );
  }


  getcampaignid(payload: any) {
    const _bot = this.sharedService.selectedBotMeta._id;
    return this.networkService.httpRequest(`integrations/mapping/get-campaign-of-get-response?botId=${_bot}`,
      null,
      'GET'
    );
  }

  createTestLead(crm: any) {
    const randomNumber = Math.random().toString();
    const mobileNo = randomNumber.slice(2, 11);
    const mail = randomNumber.slice(2, 4);
    return this.networkService.httpRequest(
      'integrations/internal/create-test-lead/',
      {
        payload: {
          avatar: '',
          name: 'Demo Lead',
          lastName: 'Demo',
          email: 'demolead' + mail + '@gmail.com',
          phone: '9' + mobileNo,
          address: 'BotPenguin',
          subject: 'This is a demo lead',
          company: 'DemoLead',
          department: 'LeadDemo Bot',
          transcript: 'DemoLead Example',
          job: 'leadTester',
          center: 'BotPenguin',
          source: 'NorthLead',
          destination: '8351989431',
          text: 'Bot Lead',
          url: 'www.demoLead.com',
          website: 'https://dev.botpenguin.relinns.com.au/',
          note: 'BotPenguion Lead',
          title: 'Demo Lead Example',
          start: new Date(),
          end: new Date(),
          due: new Date(),
          uploaddoc: 'demoImage',
          dialCode: '',
          country: 'India',
          location: 'Noida (Sector)',
          lastSeen: '2022-10-06T04:55:39.250Z',
          device: 'Desktop( )',
          browser: 'Chrome 103.0.0.0',
          ip: '203.100.78.18',
          description: 'New task Created',
          start_date: '05-21-2023',
          end_date: '05-22-2023',
          duration: 5,
          priority: 'None',
          notes: '',
          urls: [
            'https://demo.com',
            null,
            null
          ],
          blocked: false,
          operatingSystem: 'Linux x86_64'
        },
        crm
      },
      'POST'
    );
  }


  checkBitrixCredentials(url, payload, method): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      fetch(url + method, {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(res => res.json())
        .then(res => {
          if (res.error) {
            reject({ message: res.error_description });
          } else {
            resolve(res);
          }
        })
        .catch(err => {
          console.log(err.message);
          reject(err);
        });
    });
  }
  public submitMappingDetails(integrationId, userId, payload) {
    return this.networkService.httpRequest(`integrations/update-mapping/${integrationId}/${userId}`, payload, 'PUT');
  }

  /**
   * @param data contains the user credentials - client id, domain, client secret
   * @returns whether creds are valid or not
   */
  public verifySalesforceAuth(data: any) {
    return this.networkService.httpRequest('integrations/internal/verify-salesforce/', { data }, 'POST');
  }

  public submitValue(intergrationId, userId, payload) {
    return this.networkService.httpRequest(`integrations/mapping/update-mapping/${intergrationId}/${userId}`, payload, 'PUT');
  }

  integrateGoogleAnalytics(payload: any) {
    return this.networkService.httpRequest(
      'bots/' + payload.currentBotId,
      {
        googleAnalyticsId: `${payload.googleAnalyticsId}`
      },
      'PATCH'
    );
  }

  integrateFacebookPixel(payload: any) {
    return this.networkService.httpRequest(
      'bots/' + payload.currentBotId,
      {
        'configuration.seoSettings.facebookPixelId': `${payload.facebookPixelId}`
      },
      'PUT'
    );
  }
  getAccountIntegrationsProviders() {
    return this.networkService.httpRequest(`integrations/account-integrations/credentials/list`);
  }

  connectChatGpt(payload: any) {
    return this.networkService.httpRequest(`bots/${payload._id}`, payload, 'PUT');
  }

  getZohoKeys(isWhitelabel: boolean, agencyMeta: any, type: 'zoho-crm' | 'zoho-desk' | 'zoho-projects') {
    if (isWhitelabel) {
      if (agencyMeta?.isAgencyConfigurationEnabled?.zoho && agencyMeta?.meta?.zoho.clientId) {

        return {
          clientId: agencyMeta?.meta?.zoho.clientId,
          redirectUrl: `${this.sharedService.validateUrl(agencyMeta?.meta?.domain?.dashboard || agencyMeta?.meta?.domains[0])}/${type}.html`
        };
      }
      return {
        clientId: '',
        redirectUrl: ''
      };
    } else {
      let redirectUrl = '';
      switch (type) {
        case 'zoho-crm':
          redirectUrl = environment.zohoCrmRedirectURL;
          break;
        case 'zoho-desk':
          redirectUrl = environment.zohoDeskRedirectURL;
          break;
        case 'zoho-projects':
          redirectUrl = environment.zohoProjectsRedirectURL;
          break;
        default:
          break;

      }
      return {
        clientId: environment.zohoClientId,
        redirectUrl
      };
    }
  }

}

